import { render, staticRenderFns } from "./TaxManagement.vue?vue&type=template&id=9fd16502&scoped=true"
import script from "./TaxManagement.vue?vue&type=script&lang=js"
export * from "./TaxManagement.vue?vue&type=script&lang=js"
import style0 from "./TaxManagement.vue?vue&type=style&index=0&id=9fd16502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd16502",
  null
  
)

export default component.exports